import { SyndicationFeed } from "api/syndicationFeed";

export const ADD_LISTINGS_LABEL = "Add listings";

export const ULOOP_PRICE_LEAD = "$5 per lead";
export const ULOOP_PRICE_FEATURED = "$250 per property per month";

export const SYNDICATION_FEED_LABEL: Record<SyndicationFeed, string> = {
  zillow: "Zillow",
  zumper: "Zumper",
  dwellsy: "Dwellsy",
  apartments_com: "Apartments.com",
  affordable_housing_com: "Affordable Housing",
  rental_beast: "Rental Beast",
  uloop: "Uloop",
  rental_source: "Rental Source",
  rent_duck: "Rent Duck",
  realtor_com: "Realtor.com"
};
